module.exports = __webpack_public_path__ + "static/media/subscidiaries-header@2x.64f29c7c.png";